import type { BaseDocument } from '../mongo/base-document.interface';
import type { Measurement, VolumeUnit, WeightUnit } from '../measurement';

export const VEHICLE_PROFILES = {
  BICYCLE: 'bicycle',
  LARGE_VEHICLE: 'large-vehicle',
  LIGHTWEIGHT_VEHICLE: 'lightweight-vehicle',
  PEDESTRIAN: 'pedestrian',
} as const;

export type VehicleProfile = (typeof VEHICLE_PROFILES)[keyof typeof VEHICLE_PROFILES];

export interface VehicleTemplate extends BaseDocument {
  code: string;
  maxOrderCapacity?: number;
  maxVolumeCapacity: Measurement<VolumeUnit>;
  maxWeightCapacity: Measurement<WeightUnit>;
  name: string;
  profile: VehicleProfile;
}

export type CreateVehicleTemplate = Omit<VehicleTemplate, keyof BaseDocument>;

export type UpdateVehicleTemplate = Partial<CreateVehicleTemplate>;
